import { Link } from "components/elements";
import {
  TableRow,
  TableRowColumn,
  ImgIcon,
  GrabsonIcon,
} from "components/layout";
import { TiVoAppProvider } from "hooks/tivoApps/types";
import { useToggle } from "hooks/utils";
import { formatDate } from "utils/date";
import { pathToUrl } from "utils/url";

import { TiVoAppRowMenu, TiVoAppSubRow } from "../../_shared";
import { DEFAULT_PATHS, IMAGES, PATHS } from "../../constants";
import { getImageUrlFromAssets, sortVariantByCreationDate } from "../../utils";
import styles from "../TiVoAppsList.scss";

interface TiVoAppRowProps {
  provider: TiVoAppProvider;
}

export function TiVoAppRow({ provider }: TiVoAppRowProps) {
  const [expanded, toggleExpanded] = useToggle(false);
  const variants = (provider.variants || []).sort(sortVariantByCreationDate);
  const hasVariants = variants.length > 0;

  return (
    <>
      <TableRow>
        <TableRowColumn className={styles.name}>
          <div onClick={hasVariants ? toggleExpanded : () => {}}>
            <GrabsonIcon
              className={hasVariants ? styles.extender : styles.extenderHidden}
              name={
                hasVariants ? (expanded ? "arrow-up" : "arrow-down") : "minus"
              }
              font="micro"
            />
            <ImgIcon
              src={
                getImageUrlFromAssets(
                  provider.assets,
                  IMAGES.PRIMARY_BRANDING_LOGO_SQUARE
                ) ||
                getImageUrlFromAssets(
                  provider.assets,
                  IMAGES.PARTNER_SOURCE_LOGO_SQUARE
                )
              }
              className={styles.icon}
            />
          </div>
          <Link
            to={pathToUrl(PATHS.detailsProvider, {
              id: provider.id,
              tabId: DEFAULT_PATHS.APP_DETAILS,
            })}
          >
            {provider.label}
          </Link>
        </TableRowColumn>
        <TableRowColumn colspan="2">
          {provider.creationDate && formatDate(new Date(provider.creationDate))}
        </TableRowColumn>
        <TableRowColumn className={styles.menu}>
          <TiVoAppRowMenu id={provider.id} />
        </TableRowColumn>
      </TableRow>
      {expanded &&
        variants.map((variant) => (
          <TiVoAppSubRow
            key={variant.id}
            provider={provider}
            variant={variant}
          />
        ))}
    </>
  );
}
